import { parse } from "date-fns";
export class Pessoa {
  avatar = null;
  codigo = null;
  naturezaSocial = null;
  nomeRazaoSocial = null;
  apelidoFantasia = null;
  dataAbertura = null;
  dataNascimento = null;
  cnpjCpf = null;
  sexo = null;
  inscricaoEstadual = null;
  inscricaoEstadualRural = null;
  inscricaoEstadual2 = null;
  inscricaoEstadualRural2 = null;
  inscricaoSuframa = null;
  rg = null;
  contato = null;
  email = null;
  telefone = null;
  celular = null;
  tiposPessoas = [];
  idTiposPessoa = [];
  imagemOriginal = null;
  observacao = null;
  ativado = true;
  obrigatoriedadeCnpjCpf = null;
  tagsPessoa = [];
  idRota = null;
  segmentoId = null;
  enderecos = [];
  marcasId = [];
  gradesId = [];
  cliente = new Cliente();
  fornecedor = new Fornecedor();
  transportadora = new Transportadora();
  colaborador = new Colaborador();
  prestadorServico = new PrestadorServico();
  profissional = new Profissional();

  constructor(
    formPessoa,
    pessoa,
    cliente,
    fornecedor,
    transportadora,
    colaborador,
    prestadorServico,
    profissional,
  ) {
    this.avatar = pessoa.avatar;
    this.codigo = pessoa.codigo;
    this.naturezaSocial = pessoa?.naturezaSocial
      ? pessoa?.naturezaSocial
      : formPessoa?.naturezaSocial;
    this.nomeRazaoSocial = formPessoa?.nomeRazaoSocial?.toUpperCase();
    this.apelidoFantasia = formPessoa?.apelidoFantasia?.toUpperCase();
    this.dataAbertura = pessoa?.dataAbertura
      ? parse(pessoa.dataAbertura?.slice(0, 10), "yyyy-MM-dd", new Date())
      : null;
    this.dataNascimento = pessoa?.dataNascimento
      ? parse(pessoa.dataNascimento.slice(0, 10), "yyyy-MM-dd", new Date())
      : null;
    this.cnpjCpf = pessoa.cnpjCpf ? pessoa.cnpjCpf.toUpperCase() : null;
    this.sexo = pessoa.sexo;
    this.inscricaoEstadual = formPessoa.inscricaoEstadual
      ? formPessoa.inscricaoEstadual?.toUpperCase()
      : null;
    this.inscricaoEstadual2 = formPessoa.inscricaoEstadual2
      ? formPessoa.inscricaoEstadual2?.toUpperCase()
      : null;
    this.inscricaoSuframa = formPessoa.inscricaoSuframa
      ? formPessoa.inscricaoSuframa.toUpperCase()
      : null;
    this.inscricaoEstadualRural = formPessoa.inscricaoEstadualRural
      ? formPessoa.inscricaoEstadualRural.toUpperCase()
      : null;
    this.inscricaoEstadualRural2 = formPessoa.inscricaoEstadualRural2
      ? formPessoa.inscricaoEstadualRural2.toUpperCase()
      : null;
    this.rg = formPessoa?.rg ? formPessoa.rg.toUpperCase() : null;
    this.contato = formPessoa?.contato
      ? formPessoa?.contato.toUpperCase()
      : null;
    this.email = pessoa.email ? pessoa.email : null;
    this.telefone = formPessoa.telefone
      ? formPessoa.telefone.replace(/\D+/g, "")
      : null;
    this.celular = formPessoa.celular
      ? formPessoa.celular.replace(/\D+/g, "")
      : null;
    this.tiposPessoas = pessoa.tiposPessoas;
    this.idTiposPessoa = pessoa?.tiposPessoas
      ? pessoa.tiposPessoas.map((tipo) => tipo.id)
      : [];
    this.imagemOriginal =
      pessoa?.id && pessoa?.avatar ? pessoa.avatar.split("/")[4] : null;
    this.observacao = formPessoa?.observacao ?? "";
    this.ativado = pessoa.ativado;
    this.obrigatoriedadeCnpjCpf = pessoa.obrigatoriedadeCnpjCpf;
    this.enderecos = pessoa?.enderecos
      ? pessoa.enderecos.map((endereco) => new Endereco(endereco))
      : [];
    this.tagsPessoa = pessoa.tagsPessoa;
    this.rotaId = pessoa.rotaId;
    this.segmentoId = pessoa.segmentoId;
    this.cliente = new Cliente(cliente);
    this.fornecedor = new Fornecedor(fornecedor);
    this.transportadora = new Transportadora(transportadora);
    this.colaborador = new Colaborador(colaborador);
    this.prestadorServico = new PrestadorServico(prestadorServico);
    this.profissional = new Profissional(profissional);
  }

  setAvatar(avatar) {
    this.avatar = avatar;
  }

  setPessoaTagsIds(listTags) {
    if (listTags?.length) {
      this.tagsPessoa = listTags.map((item) => item.id);
    }
  }

  setCnpjCpf(id, pessoa, formPessoa) {
    if (id) {
      if (pessoa.cnpjCpf) {
        this.cnpjCpf = pessoa.cnpjCpf;
      } else {
        this.cnpjCpf = formPessoa.cnpjCpf
          ?.replace(/[^A-Za-z0-9]/g, "")
          .toUpperCase();
      }
    } else {
      this.email =
        formPessoa.email && formPessoa.email !== "" ? formPessoa.email : null;
      this.cnpjCpf = formPessoa.cnpjCpf
        ?.replace(/[^A-Za-z0-9]/g, "")
        .toUpperCase();
    }
  }

  setInformacoesBuscaCnpj(buscaCnpjRealizada, pessoa) {
    if (buscaCnpjRealizada) {
      this.nomeRazaoSocial = pessoa?.nomeRazaoSocial.toUpperCase();
      this.apelidoFantasia = pessoa?.apelidoFantasia.toUpperCase();
      this.email = pessoa?.email;
    }
  }
}

class Endereco {
  cep = null;
  logradouro = null;
  numero = null;
  bairro = null;
  complemento = null;
  descricao = null;
  padrao = null;
  cidadeId = null;

  constructor(endereco) {
    this.id = endereco?.id;
    this.cep = endereco.cep;
    this.logradouro = endereco.logradouro;
    this.numero = endereco.numero;
    this.bairro = endereco.bairro;
    this.complemento = endereco.complemento;
    this.descricao = endereco.descricao;
    this.padrao = endereco.padrao;
    this.cidadeId = endereco.cidadeId;
  }
}

export class Cliente {
  indicadorConsumidorFinal = null;
  tipoContribuinteId = null;
  tabelaPrecoPadraoId = null;
  mensagemVenda = null;
  limiteCompra = null;
  grupoPessoaId = null;
  sugestaoVendedorId = null;
  meiosPagamento = null;
  dependentes = null;
  marcasId = null;
  gradesId = null;
  tipoCompraGovernamental = null;
  percentualReducaoIbs = null;
  tipoOperacaoGovernamental = null;

  constructor(cliente) {
    if (cliente) {
      this.id = cliente?.id;
      this.indicadorConsumidorFinal =
        cliente?.indicadorConsumidorFinal == "true";
      this.tipoContribuinteId = cliente.tipoContribuinteId;
      this.tabelaPrecoPadraoId = cliente.tabelaPrecoPadraoId;
      this.mensagemVenda = cliente.mensagemVenda;
      if (cliente.limiteCompra) {
        this.limiteCompra = parseFloat(cliente.limiteCompra);
      }
      this.grupoPessoaId = cliente.grupoPessoaId;
      this.sugestaoVendedorId = cliente.sugestaoVendedorId;
      this.meiosPagamento = cliente.meiosPagamento;
      this.dependentes = cliente.dependentes;
      this.marcasId = cliente.marcas?.map(({ id }) => id);
      this.gradesId = cliente.grades?.map(({ id }) => id);
      this.orgaoGovernamental = cliente.orgaoGovernamental;
      if (cliente.orgaoGovernamental) {
        this.tipoCompraGovernamental = cliente.tipoCompraGovernamental;
        this.percentualReducaoIbs = cliente.percentualReducaoIbs;
        this.tipoOperacaoGovernamental = cliente.tipoOperacaoGovernamental;
      }
    }
  }

  setClienteMeiosPagamentoIds(listMeiosPagamento) {
    if (listMeiosPagamento?.length) {
      this.meiosPagamento = listMeiosPagamento.map((item) => item.id);
    }
  }

  setDependentes(listDependentes) {
    if (listDependentes?.length) {
      this.dependentes = listDependentes;
    }
  }
}

export class Fornecedor {
  limiteCompra = null;
  grupoPessoaId = null;

  constructor(fornecedor) {
    if (fornecedor) {
      this.id = fornecedor?.id;
      this.grupoPessoaId = fornecedor.grupoPessoaId;
      if (fornecedor.limiteCompra) {
        this.limiteCompra = parseFloat(fornecedor.limiteCompra);
      }
    }
  }
}

export class Transportadora {
  ufEmbarque = null;
  localEmbarque = null;
  localDesembarque = null;
  rntc = null;
  grupoPessoaId = null;

  constructor(transportadora) {
    if (transportadora) {
      this.id = transportadora?.id;
      this.ufEmbarque = transportadora.ufEmbarque;
      this.localEmbarque = transportadora.localEmbarque;
      this.localDesembarque = transportadora.localDesembarque;
      this.rntc = transportadora.rntc;
      this.grupoPessoaId = transportadora.grupoPessoaId;
    }
  }
}

export class Colaborador {
  dataAdmissao = null;
  funcao = null;
  vendedor = null;
  dataDemissao = null;
  grupoPessoaId = null;
  usuarioId = null;
  bancoCaixaId = null;
  comissaoPrazo = null;
  comissaoVista = null;
  descontoMaximo = null;
  motorista = null;

  constructor(colaborador) {
    if (colaborador) {
      this.id = colaborador?.id;
      this.dataAdmissao = colaborador.dataAdmissao;
      this.funcao = colaborador.funcao;
      this.vendedor = colaborador.vendedor;
      this.motorista = colaborador.motorista;
      this.dataDemissao = colaborador.dataDemissao;
      this.grupoPessoaId = colaborador.grupoPessoaId;
      this.usuarioId = colaborador.usuarioId;
      this.bancoCaixaId = colaborador.bancoCaixaId;
      this.comissaoPrazo = colaborador.comissaoPrazo;
      this.comissaoVista = colaborador.comissaoVista;
      this.descontoMaximo = colaborador.descontoMaximo;
    }
  }
}

export class PrestadorServico {
  profissao = null;
  grupoPessoaId = null;
  comissaoPrazo = null;
  comissaoVista = null;

  constructor(prestadorServico) {
    if (prestadorServico) {
      this.id = prestadorServico?.id;
      this.profissao = prestadorServico.profissao;
      this.grupoPessoaId = prestadorServico.grupoPessoaId;
      this.comissaoPrazo = prestadorServico.comissaoPrazo;
      this.comissaoVista = prestadorServico.comissaoVista;
    }
  }
}

export class Profissional {
  profissao = null;
  grupoPessoaId = null;
  comissao = null;

  constructor(profissional) {
    if (profissional) {
      this.id = profissional?.id;
      this.profissao = profissional.profissao;
      this.grupoPessoaId = profissional.grupoPessoaId;
      this.comissao = profissional.comissao;
    }
  }
}
